export default "__VITE_PUBLIC_ASSET__ee29ad12__"